module.exports = __webpack_public_path__ + "static/media/APP_OfficeWorm_152x174_6.7056b27d.png";